module.exports = __webpack_public_path__ + "static/img/digitization2.9ee163dc.png";